import styles from './Logo.module.css';

/**
 * Solvora logomark: an interlocking double-S built from two overlapping
 * gradient strokes inside a hexagonal frame.
 *
 * ASSET SLOT: if you have a final vector logo, drop it at
 * `src/assets/logo.svg` and swap the <svg> below for
 * `<img src="/src/assets/logo.svg" alt="Solvora" className={styles.mark} />`.
 */
export default function Logo({ withWordmark = true, size = 34 }) {
  return (
    <span className={styles.logo}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={styles.mark}
        aria-hidden={withWordmark}
        role={withWordmark ? undefined : 'img'}
      >
        <defs>
          <linearGradient id="solvora-logo-grad" x1="2" y1="4" x2="38" y2="36" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#4F6DF9" />
            <stop offset="0.55" stopColor="#8B5CF6" />
            <stop offset="1" stopColor="#E040C0" />
          </linearGradient>
        </defs>
        <path
          d="M20 3 34.6 11.5v17L20 37 5.4 28.5v-17L20 3Z"
          stroke="url(#solvora-logo-grad)"
          strokeWidth="2"
        />
        <path
          d="M27 13.5c0-2.5-2.6-4.3-6-4.3-3.9 0-6.4 2-6.4 4.4 0 2.7 2.4 3.7 6 4.4 4.2.8 8 1.8 8 5.9 0 3-2.9 5.5-7.4 5.5-4 0-6.9-1.8-7.6-4.6"
          stroke="url(#solvora-logo-grad)"
          strokeWidth="2.6"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      {withWordmark && <span className={styles.wordmark}>Solvora</span>}
    </span>
  );
}
